/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DocumentIconOutline, FolderIconSolid } from '@neo4j-ndl/react/icons';
import { TreeView } from '@neo4j-ndl/react/next';
import { useState } from 'react';

const Component = () => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [selected, setSelected] = useState<string | null>(null);

  const toggle = (key: string) =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <TreeView ariaLabel="File explorer">
      <TreeView.Item
        title="Documents"
        hasChildren
        isExpanded={expanded['documents']}
        onExpandedChange={() => toggle('documents')}
        isSelected={selected === 'documents'}
        onSelectedChange={() => setSelected('documents')}
        leadingVisual={<FolderIconSolid />}
      >
        <TreeView.Item
          title="Work"
          hasChildren
          isExpanded={expanded['work']}
          onExpandedChange={() => toggle('work')}
          isSelected={selected === 'work'}
          onSelectedChange={() => setSelected('work')}
          leadingVisual={<FolderIconSolid />}
        >
          <TreeView.Item
            title="Report.pdf"
            isSelected={selected === 'report'}
            onSelectedChange={() => setSelected('report')}
            leadingVisual={<DocumentIconOutline />}
          />
          <TreeView.Item
            title="Presentation.pptx"
            isDisabled
            isSelected={selected === 'presentation'}
            onSelectedChange={() => setSelected('presentation')}
            leadingVisual={<DocumentIconOutline />}
          />
        </TreeView.Item>
        <TreeView.Item
          title="Resume.pdf"
          isSelected={selected === 'resume'}
          onSelectedChange={() => setSelected('resume')}
          leadingVisual={<DocumentIconOutline />}
        />
      </TreeView.Item>
      <TreeView.Item
        title="Images (disabled)"
        hasChildren
        isExpanded={expanded['images']}
        onExpandedChange={() => toggle('images')}
        isSelected={selected === 'images'}
        onSelectedChange={() => setSelected('images')}
        leadingVisual={<FolderIconSolid />}
        isDisabled
      />
      <TreeView.Item
        title="README.md"
        isSelected={selected === 'readme'}
        onSelectedChange={() => setSelected('readme')}
        leadingVisual={<DocumentIconOutline />}
      />
    </TreeView>
  );
};

export default Component;
